// Styles
import styles from './opt-in-text.module.scss'

interface OptInTextProps {
  optInText?: string
}

const OptInText = ({optInText}: OptInTextProps) => {
  if (optInText) {
    return (
      <div
        dangerouslySetInnerHTML={{__html: optInText}}
        className={styles['opt-in-text']}
      >
      </div>
    )
  } else {
    return null
  }
}

export default OptInText
